<template>
<div>
  <ConfirmacaoDados v-model="mostrarModalConfirmacao" @confirmar="substituirDados" @fechar="fecharModal" :novosDados="novosDados" :mapeamentoCampos="mapeamentoCampos"/>
  <div class="row">
    <div class="col-xl-3 col-lg-3 col-md-3 col-xs-12 col-sm-12">
      <div class="form-group">
        <label :class="{ 'required': obrigatorio.cep }">CEP</label>
        <input v-model="formulario.cep" class="form-control" @change="buscarEndereco(formulario.cep)" v-mask="mascaraCep" :disabled="desabilitarCampos"/>
        <slot name="erro-cep">
          <div class="avisoDanger text-left mt-1">
            {{ listaDeErros.cep }}
          </div>
        </slot>
      </div>
    </div>
    <div class="col-xl-9 col-lg-9 col-md-9 col-xs-12 col-sm-12">
      <div class="form-group">
        <label :class="{ 'required': obrigatorio.endereco }">Endereço</label>
        <input v-model="formulario.endereco" class="form-control" :disabled="desabilitarCampos"/>
        <slot name="erro-endereco">
          <div class="avisoDanger text-left mt-1">
            {{ listaDeErros.endereco }}
          </div>
        </slot>
      </div>
    </div>
    <div class="col-xl-6 col-lg-6 col-md-6 col-xs-12 col-sm-12">
      <div class="form-group">
        <label :class="{ 'required': obrigatorio.numero }">Número</label>
        <input v-mask="'#####'" v-model="formulario.numero" class="form-control" :disabled="desabilitarCampos"/>
        <slot name="erro-numero">
          <div class="avisoDanger text-left mt-1">
            {{ listaDeErros.numero }}
          </div>
        </slot>
      </div>
    </div>
    <div class="col-xl-6 col-lg-6 col-md-6 col-xs-12 col-sm-12">
      <div class="form-group">
        <label :class="{ 'required': obrigatorio.complemento }">Complemento</label>
        <input v-model="formulario.complemento" class="form-control" :disabled="desabilitarCampos"/>
        <slot name="erro-complemento">
          <div class="avisoDanger text-left mt-1">
            {{ listaDeErros.complemento }}
          </div>
        </slot>
      </div>
    </div>
    <div class="col-xl-6 col-lg-6 col-md-6 col-xs-12 col-sm-12">
      <div class="form-group">
        <label :class="{ 'required': obrigatorio.bairro }">Bairro</label>
        <input v-model="formulario.bairro" class="form-control" :disabled="desabilitarCampos"/>
        <slot name="erro-bairro">
          <div class="avisoDanger text-left mt-1">
            {{ listaDeErros.bairro }}
          </div>
        </slot>
      </div>
    </div>
    <div class="col-xl-6 col-lg-6 col-md-6 col-xs-12 col-sm-12">
      <div class="form-group">
        <label :class="{ 'required': obrigatorio.cidade }">Cidade</label>
        <input v-model="formulario.cidade" class="form-control" :disabled="desabilitarCampos"/>
        <slot name="erro-cidade">
          <div class="avisoDanger text-left mt-1">
            {{ listaDeErros.cidade }}
          </div>
        </slot>
      </div>
    </div>
    <div class="col-xl-6 col-lg-12 col-md-6 col-xs-12 col-sm-12 form-group">
      <label for="uf" :class="{ 'required': obrigatorio.uf }">Unidade Federativa</label>
        <v-select
          id="uf"
          class="comboFonteDefault style-chooser"
          v-model="formulario.uf"
          :options="combosUnidadesFederativas"
          @search="eventoDigitarBuscaPorUnidadeFederativa"
          :disabled="desabilitarCampos"
          :filterable="false"
        >
          <template v-slot:no-options>
            <em>Nenhum registro encontrado.</em>
          </template>
        </v-select>
        <div class="avisoDanger text-left mt-1">
          {{ listaDeErros.uf }}
        </div>
    </div>
  </div>
</div>
</template>

<script>
import Endereco from './js'
export default Endereco
</script>

<style scoped>
@import "./scss/endereco.scss";
</style>
